<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_715_15697)">
      <path
        d="M2.84296 9.91896C2.85205 10.0046 2.86129 10.0913 2.87063 10.1788L3.01537 11.5357C3.11697 12.4886 3.20507 13.3151 3.35879 13.9746C3.52416 14.684 3.79678 15.3524 4.36528 15.8825C4.9338 16.4125 5.60161 16.621 6.29681 16.7137C6.94303 16.8001 7.74127 16.8 8.66174 16.8H14.8289C15.46 16.8 16.0169 16.8 16.482 16.7508C16.986 16.6975 17.4756 16.5794 17.9464 16.2841C18.4173 15.9888 18.7466 15.5933 19.0277 15.1543C19.287 14.7492 19.5476 14.2364 19.8427 13.6556L22.7106 8.0128C23.7282 6.01064 22.3349 3.59998 20.16 3.59998H8.52346C7.39128 3.59992 6.42269 3.59986 5.65601 3.71144C5.26798 3.76793 4.88775 3.85835 4.53111 4.0125L4.3654 2.45894C4.21608 1.05906 3.08016 0 1.728 0H1.152C0.515773 0 0 0.537252 0 1.2C0 1.86274 0.515773 2.4 1.152 2.4H1.728C1.90616 2.4 2.05581 2.53954 2.07549 2.72398L2.84296 9.91896Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.8242 21C13.8242 19.3432 15.1137 18 16.7042 18C18.2948 18 19.5842 19.3432 19.5842 21C19.5842 22.6568 18.2948 24 16.7042 24C15.1137 24 13.8242 22.6568 13.8242 21Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.45581 21C3.45581 19.3432 4.74523 18 6.33581 18C7.92639 18 9.21581 19.3432 9.21581 21C9.21581 22.6568 7.92639 24 6.33581 24C4.74523 24 3.45581 22.6568 3.45581 21Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_715_15697">
        <rect width="24" height="24" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
</template>
